module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2018/april-66bcb2a2fad9b1014716dc28dcc7639a.png";